module.exports = __webpack_public_path__ + "img/3.954a4052.svg";